import { render, staticRenderFns } from "./ContratosDash2.vue?vue&type=template&id=d37ee90c"
import script from "./ContratosDash2.vue?vue&type=script&lang=js"
export * from "./ContratosDash2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports